import { ICurrentUserRepository } from '../../ports/ICurrentUserRepository';

export class GetCurrentUserUseCase {
  constructor(private repo: ICurrentUserRepository) {}
  execute() {
    return this.repo.get();
  }
}
